import { render } from "./ServicePartner.vue?vue&type=template&id=3dd0151f"
import script from "./ServicePartner.vue?vue&type=script&lang=ts"
export * from "./ServicePartner.vue?vue&type=script&lang=ts"

import "./ServicePartner.vue?vue&type=style&index=0&id=3dd0151f&lang=scss"
script.render = render

export default script